export interface ITransactionData {}

export enum WithdrawalType {
    QuickCash = 'quick-cash',
    DirectWithdrawal = 'direct-withdrawal',
    QuickCrypto = 'quick-crypto',
    QuickMobile = 'quick-mobile',
    // Ghana mobile money via Breet — its own flow (/app/momo-withdraw), never a Withdraw.
    MobileMoney = 'mobile-money',
}
